'use client';

import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import PFSection from './PFSection';
import PFParagraph from './PFParagraph';
import { useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import '@/common/tokens.stylex';
import { colors } from '@/common/tokens.stylex';
type Props = {
  job: string;
};
export function JobsFAQ(props: Props) {
  const [questionsOpened, setQuestionsOpened] = useState(false);
  return <PFSection standardPadding style={styles.section}>
      <div>
        <button className="xdpxx8g xh8yej3 x78zum5 x1q0g3np x6s0dn4 x1qughib x1ypdohk x-default-marker" onClick={() => setQuestionsOpened(lastState => !lastState)}>
          <h2 className="x1aegnp4 x1rth2hy">
            Noch Fragen zum Bewerbungsprozess?
          </h2>
          {!questionsOpened && <IoIosArrowDown className="x100vrsf x1vqgdyp x1rth2hy" />}
          {questionsOpened && <IoIosArrowUp className="x100vrsf x1vqgdyp x1rth2hy" />}
        </button>
      </div>
      {questionsOpened && <>
          {props.job === 'Volontariat' && <>
              <h3 className="x1cnzs8 x1ducrmg">
                Wie bewerbe ich mich und was brauche ich dafür?
              </h3>
              <PFParagraph>
                Du klickst einfach{' '}
                <a href="#FormSection" className="x10fmesz xz4gly6 x1d8287x xsgz8l0 x1277o0a">
                  HIER
                </a>
                , fügst deine Kontaktdaten ein und lädst deinen Lebenslauf hoch.
                Wenn du ganz fancy unterwegs bist, kannst du natürlich auch ein
                Anschreiben reinpacken – wir lernen dich aber sowieso lieber
                persönlich kennen!
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Was passiert, wenn ich meine Bewerbung abgeschickt habe?
              </h3>
              <PFParagraph>
                Du bekommst von uns direkt eine Eingangsbestätigung. Da wir
                deine Bewerbungsunterlagen so fix wie möglich prüfen, bekommst
                du innerhalb einer Woche eine Rückmeldung von uns – im besten
                Fall eine Einladung zum Vorstellungsgespräch.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie läuft das Vorstellungsgespräch ab?
              </h3>
              <PFParagraph>
                Bei uns wirst du nicht gegrillt – uns geht es vorrangig darum,
                dich besser kennenzulernen! In einem Google-Meets-Videocall
                wollen wir mehr über dich erfahren und erzählen dir alles
                Wichtige über das Volo.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie geht’s nach dem Gespräch weiter?
              </h3>
              <PFParagraph>
                Wenn du im Gespräch überzeugen konntest, bekommst du ein paar
                Aufgaben von uns, dabei geht es beispielsweise um die Erstellung
                von Probeartikeln.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie geht’s nach den Aufgaben weiter?
              </h3>
              <PFParagraph>
                Du konntest uns auf voller Linie überzeugen? Klasse, dann geben
                wir dir innerhalb von zwei Tagen Bescheid und senden dir
                anschließend den Vertrag per Post zu.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Vertrag unterschrieben – und jetzt?
              </h3>
              <PFParagraph>
                Wir bleiben in Kontakt! Du bekommst von uns Infos zum ersten
                Tag, Ablauf des Mentorings und alles, was du sonst noch wissen
                musst... und wenn du vor deinem Start mal in der Nähe bist,
                komm’ doch einfach auf einen Kaffee vorbei!
              </PFParagraph>
            </>}
          {props.job === 'Lektor' && <>
              <h3 className="x1cnzs8 x1ducrmg">
                Wie bewerbe ich mich und was brauche ich dafür?
              </h3>
              <PFParagraph>
                Du klickst einfach{' '}
                <a href="#FormSection" className="x10fmesz xz4gly6 x1d8287x xsgz8l0 x1277o0a">
                  HIER
                </a>
                , fügst deine Kontaktdaten ein und lädst deinen Lebenslauf hoch.
                Wenn du ganz fancy unterwegs bist, kannst du natürlich auch ein
                Anschreiben reinpacken – wir lernen dich aber sowieso lieber
                persönlich kennen!
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Was passiert, wenn ich meine Bewerbung abgeschickt habe?
              </h3>
              <PFParagraph>
                Du bekommst von uns direkt eine Eingangsbestätigung. Da wir
                deine Bewerbungsunterlagen so fix wie möglich prüfen, bekommst
                du innerhalb einer Woche eine Rückmeldung von uns – im besten
                Fall eine Einladung zum Probelektorat.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">Wie läuft das Probelektorat ab?</h3>
              <PFParagraph>
                Das Probelektorat findet online statt und dauert etwa eine
                Stunde. Wir vereinbaren vorab mit dir einen Termin, an dem du
                dann eine Mail mit einer Lektorats-Aufgabe bekommst, sodass du
                die Aufgabe von zu Hause aus bearbeiten kannst.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie geht’s nach dem Probelektorat weiter?
              </h3>
              <PFParagraph>
                Wenn du im Probelektorat überzeugen konntest, bekommst du von
                uns eine Einladung zum Vorstellungsgespräch, das hier in unserem
                Büro stattfindet. In einem kurzen Gespräch lernen wir uns besser
                kennen und du erfährst alles Wichtige über den Job als
                Promiflash-Lektor*.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie geht’s nach dem Vorstellungsgespräch weiter?
              </h3>
              <PFParagraph>
                Du konntest uns auf voller Linie überzeugen? Klasse, dann geben
                wir dir innerhalb von wenigen Tagen Bescheid und senden dir
                anschließend den Vertrag per Post zu.
              </PFParagraph>
            </>}
          {props.job === 'Sprecher' && <>
              <h3 className="x1cnzs8 x1ducrmg">
                Wie bewerbe ich mich und was brauche ich dafür?
              </h3>
              <PFParagraph>
                Du klickst einfach{' '}
                <a href="#FormSection" className="x10fmesz xz4gly6 x1d8287x xsgz8l0 x1277o0a">
                  HIER
                </a>
                , fügst deine Kontaktdaten ein und lädst deinen Lebenslauf hoch.
                Wenn du ganz fancy unterwegs bist, kannst du natürlich auch ein
                Anschreiben reinpacken – wir lernen dich aber sowieso lieber
                persönlich kennen!
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Was passiert, wenn ich meine Bewerbung abgeschickt habe?
              </h3>
              <PFParagraph>
                Du bekommst von uns direkt eine Eingangsbestätigung. Da wir
                deine Bewerbungsunterlagen so fix wie möglich prüfen, bekommst
                du innerhalb einer Woche eine Rückmeldung von uns – im besten
                Fall eine Einladung zum Online-Casting.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie läuft das Online-Casting ab und was passiert danach?
              </h3>
              <PFParagraph>
                Damit wir uns ein noch besseres Bild von deiner Stimme machen
                können, bekommst Du von uns eine Mail mit verschiedenen
                Promiflash-Texten, die du zu Hause einsprichst und uns danach
                zuschickst. Wir prüfen dann, ob deine Stimme zu unserem Produkt
                passt. Wenn ja, erhältst du eine Einladung zum
                Vorstellungsgespräch.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie läuft das Vorstellungsgespräch ab?
              </h3>
              <PFParagraph>
                In einem kurzen Gespräch, das hier in unserem Büro stattfindet,
                lernen wir uns besser kennen und du erfährst alles Wichtige über
                den Job als Promiflash-Sprecher*. Auch zeigen wir dir direkt
                unsere Tonkabine, in der du dich – wenn du magst – auch gleich
                mal kurz ausprobieren kannst.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie geht’s nach dem Vorstellungsgespräch weiter?
              </h3>
              <PFParagraph>
                Du konntest uns auf voller Linie überzeugen? Klasse, dann geben
                wir dir innerhalb von wenigen Tagen Bescheid und senden dir
                anschließend den Vertrag per Post zu.
              </PFParagraph>
            </>}
          {props.job !== ('Volontariat' || 'Lektor' || 'Sprecher') && <>
              <h3 className="x1cnzs8 x1ducrmg">
                Wie bewerbe ich mich und was brauche ich dafür?
              </h3>
              <PFParagraph>
                Du klickst einfach{' '}
                <a href="#FormSection" className="x10fmesz xz4gly6 x1d8287x xsgz8l0 x1277o0a">
                  HIER
                </a>
                , fügst deine Kontaktdaten ein und lädst deinen Lebenslauf hoch.
                Wenn du ganz fancy unterwegs bist, kannst du natürlich auch ein
                Anschreiben reinpacken – wir lernen dich aber sowieso lieber
                persönlich kennen!
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Was passiert, wenn ich meine Bewerbung abgeschickt habe?
              </h3>
              <PFParagraph>
                Du bekommst von uns direkt eine Eingangsbestätigung. Da wir
                deine Bewerbungsunterlagen so fix wie möglich prüfen, bekommst
                du innerhalb einer Woche eine Rückmeldung von uns – im besten
                Fall eine Einladung zum Vorstellungsgespräch.
              </PFParagraph>
              <h3 className="xz9dl7a xjk278a x1ducrmg">
                Wie geht’s nach dem Vorstellungsgespräch weiter?
              </h3>
              <PFParagraph>
                Du konntest uns auf voller Linie überzeugen? Klasse, dann geben
                wir dir innerhalb von wenigen Tagen Bescheid und senden dir
                anschließend den Vertrag per Post zu.
              </PFParagraph>
            </>}
        </>}
    </PFSection>;
}
const styles = {
  section: {
    kWkggS: "x15wbugh x1oqs81x",
    k8WAf4: "xd11lqx",
    $$css: true
  }
};